import { kmsClient } from 'api';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import { IMAGE_OR_VIDEO_CREATIVE_TEMPLATES } from './imageOrVidoeCreativeTemplates.query';
import { UPDATE_CREATIVE_TEMPLATE_MUTATION } from './updateCreativeTemplates.mutation';
import {
  ImageOrVideoCreativeTemplates,
  ImageOrVideoCreativeTemplatesVariables
} from './__generated__/ImageOrVideoCreativeTemplates';
import {
  UpdateCreativeTemplateMutation,
  UpdateCreativeTemplateMutationVariables
} from './__generated__/UpdateCreativeTemplateMutation';

import { DELETE_CREATIVE_TEMPLATE_MUTATION } from './deleteCreativeTemplate.mutation';
import {
  DeleteCreativeTemplateMutation,
  DeleteCreativeTemplateMutationVariables
} from './__generated__/DeleteCreativeTemplateMutation';

export const useImageOrVideoCreativeTemplatesQuery = (variables: ImageOrVideoCreativeTemplatesVariables) => {
  return useQuery<ImageOrVideoCreativeTemplates>(IMAGE_OR_VIDEO_CREATIVE_TEMPLATES, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};

export const useCreativeTemplatesLazyQuery = (variables: ImageOrVideoCreativeTemplatesVariables) => {
  return useLazyQuery<ImageOrVideoCreativeTemplates>(IMAGE_OR_VIDEO_CREATIVE_TEMPLATES, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};

export const useUpdateCreativeTemplate = () => {
  const [updateCreativeTemplate] = useMutation<UpdateCreativeTemplateMutation, UpdateCreativeTemplateMutationVariables>(
    UPDATE_CREATIVE_TEMPLATE_MUTATION,
    {
      client: kmsClient
    }
  );
  return (variables: UpdateCreativeTemplateMutationVariables) =>
    updateCreativeTemplate({ variables }).then((response) =>
      response.data?.updateCreativeTemplate?.errors?.length
        ? Promise.reject(response.data.updateCreativeTemplate.errors)
        : response.data?.updateCreativeTemplate?.imageOrVideoCreativeTemplate
    );
};

export const useDeleteCreativeTemplate = () => {
  const [deleteCreativeTemplate] = useMutation<DeleteCreativeTemplateMutation, DeleteCreativeTemplateMutationVariables>(
    DELETE_CREATIVE_TEMPLATE_MUTATION,
    {
      client: kmsClient
    }
  );
  return (variables: DeleteCreativeTemplateMutationVariables) =>
    deleteCreativeTemplate({ variables }).then((response) =>
      response.data?.deleteCreativeTemplate?.errors?.length
        ? Promise.reject(response.data.deleteCreativeTemplate.errors)
        : response.data?.deleteCreativeTemplate?.creativeTemplate
    );
};
